import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border-soft);
  padding: 12px 8px 12px 12px;

  &:not(:last-child) {
    border-bottom: none;
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  cursor: pointer;
  &:hover {
    background-color: var(--surface-hover);
  }
`;

export const NameWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  ${typographyV2.bodySm};
`;

export const Name = styled.span`
  ${typographyV2.bodySm};
`;
